/**
 * Utility functions for organization-related operations
 */

/** Module name: memberships */
export const MODULE_MEMBERSHIPS = 'memberships'

/** Module name: online payments */
export const MODULE_ONLINE_PAYMENTS = 'online_payments'

/** Organization column: module_membership_enabled */
export const ORG_FIELD_MODULE_MEMBERSHIP_ENABLED = 'module_membership_enabled'

/** Organization column: module_online_payments_enabled */
export const ORG_FIELD_MODULE_ONLINE_PAYMENTS_ENABLED = 'module_online_payments_enabled'

/**
 * Check if a specific module is enabled (by column or legacy organization_settings).
 * @param {Object} organization - The organization object
 * @param {string} moduleName - MODULE_MEMBERSHIPS | MODULE_ONLINE_PAYMENTS
 * @returns {boolean} - True if the module is enabled
 */
export function isModuleEnabled(organization, moduleName) {
  if (!organization) return false
  if (moduleName === MODULE_MEMBERSHIPS) {
    return organization[ORG_FIELD_MODULE_MEMBERSHIP_ENABLED] === true
  }
  if (moduleName === MODULE_ONLINE_PAYMENTS) {
    return organization[ORG_FIELD_MODULE_ONLINE_PAYMENTS_ENABLED] === true
  }
  return false
}

/**
 * Check if memberships module is enabled (column module_membership_enabled).
 * @param {Object} organization - The organization object
 * @returns {boolean} - True if memberships module is enabled
 */
export function isMembershipModuleEnabled(organization) {
  return isModuleEnabled(organization, MODULE_MEMBERSHIPS)
}

/** Organization column that switches the given module on or off. */
const MODULE_ENABLED_FIELD = {
  [MODULE_MEMBERSHIPS]: ORG_FIELD_MODULE_MEMBERSHIP_ENABLED,
  [MODULE_ONLINE_PAYMENTS]: ORG_FIELD_MODULE_ONLINE_PAYMENTS_ENABLED
}

/**
 * Patch payload that turns a module on or off, for `dashboard/patchActiveOrganization`.
 * One place for the module → column mapping so the settings index and the module pages agree.
 * @param {string} moduleName MODULE_MEMBERSHIPS | MODULE_ONLINE_PAYMENTS
 * @param {boolean} enabled
 */
export function buildModuleEnabledPatch(moduleName, enabled) {
  const field = MODULE_ENABLED_FIELD[moduleName]
  if (!field) throw new Error(`Unknown module: ${moduleName}`)
  return { [field]: enabled === true }
}
